import { render, staticRenderFns } from "./GeneralStatusPage.vue?vue&type=template&id=1f884f01"
import script from "./GeneralStatusPage.vue?vue&type=script&lang=js"
export * from "./GeneralStatusPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports